import { render, staticRenderFns } from "./HoldCard.vue?vue&type=template&id=2c515158&scoped=true&"
import script from "./HoldCard.vue?vue&type=script&lang=js&"
export * from "./HoldCard.vue?vue&type=script&lang=js&"
import style0 from "./HoldCard.vue?vue&type=style&index=0&id=2c515158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c515158",
  null
  
)

export default component.exports